import { Types } from '../../../../../actions/dashboards'
import { Metrics } from '../../../../../constants/Dashboards'
import buildAsyncStatReducer from '../../asyncStatReducer'
import { WFHInteractionsTotal } from './types'

/**
 * WFH total interactions reducer
 */
const wfhInteractionsTotal = buildAsyncStatReducer({
    key: Metrics.WFH_INTERACTIONS_TOTAL,
    types: {
        request: Types.DASHBOARD_WFH_INTERACTIONS_TOTALS.request,
        success: Types.DASHBOARD_WFH_INTERACTIONS_TOTALS.success,
        failure: Types.DASHBOARD_WFH_INTERACTIONS_TOTALS.failure,
    },
    transform: (state, { payload }): WFHInteractionsTotal => {
        const item = payload[0] || {}
        const total: number = item.count
        return { total }
    },
})

export default wfhInteractionsTotal
